/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

function sendGet ( url ) {
    core.backend.request(url, {
        method: 'GET'
    });
}


function Advertising ( config ) {
    config = config || {};

    /**
     * Tracking points
     *
     * @type {object}
     */
    this.tracking = config.tracking || {};

    /**
     * Number of seconds required to watch advertising
     *
     * @type {number} requiredPart to watch advertising
     */
    this.requiredPart = config['skip_after'];

    /**
     * Info about advertising campaign
     */
    this.campaign = config.campaign;

    /**
     * Url to vatch advertising
     *
     * @type {string}
     */
    this.url = config.video;

}

// Advertising.

Advertising.prototype = {};
Advertising.prototype.constructor = Advertising;


/**
 * Track start playback
 */
Advertising.prototype.start = function () {
    if ( this.tracking.start ) {
        this.tracking.start.forEach(sendGet);
    }
};


/**
 * Track 25% playback
 */
Advertising.prototype.quarter = function () {
    if ( this.tracking.firstQuartile ) {
        this.tracking.firstQuartile.forEach(sendGet);
    }

    this.quarter = null;
};


/**
 * Track 50% playback
 */
Advertising.prototype.middle = function () {
    if ( this.tracking.midpoint ) {
        this.tracking.midpoint.forEach(sendGet);
    }

    this.middle = null;
};


/**
 * Track 75% playback
 */
Advertising.prototype.thirdQuarter = function () {
    if ( this.tracking.thirdQuartile ) {
        this.tracking.thirdQuartile.forEach(sendGet);
    }

    this.thirdQuarter = null;
};

/**
 * Track 100% playback
 */
Advertising.prototype.complete = function () {
    if ( this.tracking.complete ) {
        this.tracking.complete.forEach(sendGet);
    }
};


module.exports = Advertising;
